import { useAtomValue } from 'jotai'
import { selectedProductAtom, TypeServicoValid } from '../state/selectProduct'
import Previdenciario from './pages/previdenciario'
import { useParams } from 'react-router-dom'
import SimplesNacional from './pages/simples_nacional'
import { useApuracaoSelecionada } from '../hooks/seApuracaoSelecionada'
import { useEffect } from 'react'
import { useFetchApuracaoByIdProduct } from '../services/useFetchApuracaoByIdProduct'
import IcmsExclusao from './pages/icms_exclusao'
import FCVS from './pages/fcvs'
import Subvencao from './pages/subvencao'

const typeServicoValidSet = new Set<TypeServicoValid>([
  TypeServicoValid.PREVIDENCIARIO,
  TypeServicoValid.PIS_COFINS_MONOFASICO_PARA_SN,
  TypeServicoValid.EXCLUSAO_DE_ICMS_E_ST,
  TypeServicoValid.NEGOCIACAO_DE_PASSIVOS,
  TypeServicoValid.FCVS,
  // TypeServicoValid.SUBVENCAO
  // TypeServicoValid.SUBVENCAO
  // outros que quiser adicionar
])

export default function ProductContent() {
  const params = useParams()
  const cnpjcpf = params.cnpjcpf || ''
  const product = useAtomValue(selectedProductAtom)
  const { data: apuracoes = [] } = useFetchApuracaoByIdProduct(product?.id ?? '')
  const { setApuracaoSelecionada } = useApuracaoSelecionada()

  useEffect(() => {
    if (product && apuracoes.length > 0) {
      // seleciona sempre o primeiro período ao trocar de produto
      setApuracaoSelecionada(apuracoes[0])
    } else {
      // limpa, caso não haja produto ou apurações
      setApuracaoSelecionada(null)
    }
  }, [product, apuracoes, setApuracaoSelecionada])
  if (!product) return null
  return (
    <div>
      {typeServicoValidSet.has(product.typeServico as unknown as TypeServicoValid) ? (
        <>
          {(product.typeServico as unknown as TypeServicoValid) === TypeServicoValid.PREVIDENCIARIO && (
            <Previdenciario cnpj={cnpjcpf} product={product} />
          )}
          {(product.typeServico as unknown as TypeServicoValid) === TypeServicoValid.PIS_COFINS_MONOFASICO_PARA_SN && (
            <SimplesNacional cnpj={cnpjcpf} product={product} />
          )}
          {(product.typeServico as unknown as TypeServicoValid) === TypeServicoValid.EXCLUSAO_DE_ICMS_E_ST && (
            <IcmsExclusao cnpj={cnpjcpf} product={product} />
          )}
          {(product.typeServico as unknown as TypeServicoValid) === TypeServicoValid.FCVS && (
            <FCVS cnpj={cnpjcpf} product={product} />
          )}
          {(product.typeServico as unknown as TypeServicoValid) === TypeServicoValid.SUBVENCAO && (
            <Subvencao cnpj={cnpjcpf} product={product} />
          )}
        </>
      ) : (
        <div className="flex flex-col items-center justify-center p-6">
          <img src="/prod-em-breve.png" alt="Produto em breve" className="max-w-[180px] opacity-80" />
          <span className="text-sm mt-2 text-muted-foreground">Produto em desenvolvimento</span>
        </div>
      )}
    </div>
  )
}
